export class AtsTrackingHelper {
    public static publishEvent(eventData: IECommerceEventData): void {
        if (window.shell) {
            const dateNow: string = new Date().toISOString();

            window.shell.publishTo('kraken.categoryviewed', {
                'version': 1,
                'eventDate': dateNow,
                'context': {
                    'senderId': 'ESPP1.ArticleTile.Service'
                },
                'type': ECommerceEvent.CategoryViewed,
                'properties': {
                    'category': eventData.navigationKey
                }
            });
        }
    }
}

export enum ECommerceEvent {
    CategoryViewed = 'CategoryViewed'
}

export interface IECommerceEventData {
    'navigationKey': string;
}